// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vRsdf","question":"styles_question__2mmS6","inputVisibleButton":"styles_inputVisibleButton__v3mOP","note":"styles_note__3-4-I"};